import { Outlet, useLocation } from "react-router";
import { Trans } from "@lingui/react/macro";
import { useAuth } from "@/auth/use-auth";
import { redirectToLogin } from "@/auth/auth";

/**
 * Route guard for authenticated users.
 *
 * Renders child routes if the user is authenticated.
 * Redirects to login if not authenticated, preserving the intended destination.
 */
export function PrivateRoute() {
  const { user, isLoading } = useAuth();
  const location = useLocation();

  if (isLoading) {
    return (
      <div className="flex items-center justify-center h-screen">
        <Trans>Loading...</Trans>
      </div>
    );
  }

  if (!user) {
    redirectToLogin(location.pathname);
    return null;
  }

  return <Outlet />;
}
